import React from 'react';
import { TreeSelect } from 'antd';

const { SHOW_PARENT } = TreeSelect;

const TreeSelect_v2 = ({ treeData,name, value, onChange, placeholder = 'Please select' }) => {
  const tProps = {
    treeData,
    value,
    name,
    onChange,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    searchPlaceholder: placeholder,
    style: {
      width: '100%',
    },
  };

  return <TreeSelect {...tProps} />;
};

export default TreeSelect_v2;
